import type { components } from '@/api/schema'

type LineStatus = components['schemas']['LineStatusRead']

/** Each PO item's status by line id (USA-1202). */
export function itemStatusesById(summary: components['schemas']['POStatusSummary'] | null | undefined) {
  return new Map<number, LineStatus>((summary?.items ?? []).map((item) => [item.line_item_id, item]))
}
